import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

function TextDivider({text, cols, textCols}){

  const classes   = useStyles();
  const myCols    = cols || 8;
  const tCols     = textCols || 2;
  const dCols     = Math.ceil((12 - tCols) / 2);

  return (
    <Grid item sm={myCols} container justifyContent="center" alignItems="center" className={classes.divider}>
      <Grid item sm={dCols} container alignItems="center">
        <Divider style={{width: "100%"}}/>          
      </Grid>
      <Grid item sm={tCols} container alignItems="center" justifyContent="center">
        {text && <Typography className={classes.info}>{text}</Typography>}
        {!text && <Divider style={{width: "100%"}}/>  }
      </Grid>
      <Grid item sm={dCols} container alignItems="center">
        <Divider style={{width: "100%"}}/>          
      </Grid>
    </Grid>
  );
}

export default TextDivider;

const useStyles  = makeStyles(theme => ({
  root      : {
    padding       : `${theme.spacing(3)}px ${theme.spacing(1)}px`,
  },
  info      : {
    marginBottom  : theme.spacing(1),
    fontSize      : 18,
    fontWeight    : 300,
    color         : theme.palette.grey[600],
  },
  divider         : {
    marginTop         : theme.spacing(1),
  },
}));